import { ChangeEvent } from 'react';

import { MenuItem, TextField } from '@material-ui/core';

import { useAggregatedMeasurement } from './context';

export type SelectProps = {
  label: string;
  helperText?: string;
  required?: boolean;
  disabledOptions?: string[];
  emptyLabel?: string;
};

export const Select = ({
  label,
  helperText,
  required,
  disabledOptions = [],
  emptyLabel = 'The number of fact rows',
}: SelectProps) => {
  const { measurement, factTable, measures, onMeasurementChange } =
    useAggregatedMeasurement();

  const handleChange = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    onMeasurementChange(e.target.value);
  };

  return (
    <TextField
      required={required}
      label={label}
      name="measurement"
      margin="dense"
      fullWidth
      variant="outlined"
      onChange={handleChange}
      value={measurement?.name ?? ''}
      disabled={!factTable}
      select
      helperText={helperText}
      SelectProps={{ displayEmpty: !!emptyLabel }}
      InputLabelProps={{ shrink: true }}
     data-track-source-anchor="eb5590595a;select-text-field">
      <MenuItem value="" divider disabled={!emptyLabel} data-track-source-anchor="7689e6e344;select-menu-item;low">
        <em>{emptyLabel}</em>
      </MenuItem>
      {measures.map(option => (
        <MenuItem
          value={option.column.name}
          key={option.column.name}
          disabled={disabledOptions.includes(option.column.name)}
         data-track-source-anchor="2e98352787;select-menu-item-2;low">
          {option.column.name}
        </MenuItem>
      ))}
    </TextField>
  );
};
